import { month } from 'is_js';
import DirectoryService from '../../directory/DirectoryService';

const ClassService = {
  convertTime(time) {
    const hour = time[0] < 10 ? '0' + time[0] : time[0];
    const min = time[1] < 10 ? '0' + time[1] : time[1];
    return hour + ':' + min;
  },
  convertDate(date) {
    const year = date[0];
    const month = date[1] < 10 ? '0' + date[1] : date[1];
    const day = date[2] < 10 ? '0' + date[2] : date[2];
    return year + '-' + month + '-' + day;
  },
  async updateClass(formData) {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      const identifier = formData.identifier;
      let updatedData = {
        ...formData,
        accountIdentifier: accountIdentifier
      };
      let url = '/api/wod/wodclass';
      let method = 'POST';

      if (identifier !== undefined) {
        const wodClass = await this.retrieveClass(identifier);
        updatedData = {
          ...wodClass,
          coach: formData.coach,
          name: formData.name.value,
          date: formData.date,
          startTime: formData.startTime,
          endTime: formData.endTime,
          cancellations: wodClass.cancellations?.map(c => ({
            ...c,
            groups: []
          })),
          absents: wodClass.absents?.map(a => ({
            ...a,
            groups: []
          })),
          attendees: wodClass.attendees?.map(a => ({
            ...a,
            groups: []
          }))
        };
        url = '/api/wod/wodclass/' + identifier;
        method = 'PUT';
      }
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const updatedClass = await response.json();
        console.log('Class has been updated:', updatedClass);
      }
    } catch (error) {
      console.log('Error saving Class', error);
    }
  },
  async saveClass(formData) {
    try {
      let url = '/api/wod/wodclass';
      let method = 'PUT';
      if (formData.identifier === undefined) {
        const profileLogged = JSON.parse(localStorage.getItem('profile'));
        const { accountIdentifier } = profileLogged;
        console.log(profileLogged);
        console.log(accountIdentifier);
        url = '/api/wod/wodclass';
        method = 'POST';
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newClass = await response.json();
        console.log('Class has been updated:', newClass);
      }
    } catch (error) {
      console.log('Error saving Class', error);
    }
  },
  async retrieveAllClassesByAccountAndDates(startDate, endDate) {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));

      const response = await fetch(
        '/api/wod/wodclass/account/' +
          accountIdentifier +
          '/' +
          startDate +
          '/' +
          endDate
      );
      const data = await response.json();
      const updatedData = data.map(d => ({
        ...d,
        date: this.convertDate(d.date),
        startTime: this.convertTime(d.startTime),
        endTime: this.convertTime(d.endTime)
      }));
      return updatedData;
    } catch (error) {
      console.error('Error fetching Class', error);
      throw error;
    }
  },
  async retrieveAllClassesByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch(
        '/api/wod/wodclass/account/' + accountIdentifier
      );
      const data = await response.json();
      const updatedData = data.map(d => ({
        ...d,
        date: this.convertDate(d.date),
        startTime: this.convertTime(d.startTime),
        endTime: d.endTime ? this.convertTime(d.endTime) : null
      }));
      return updatedData;
    } catch (error) {
      console.error('Error fetching Class', error);
      throw error;
    }
  },
  async retrieveleaderboard() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const date = new Date();
      const year = date.getFullYear();
      // getMonth() is 0-indexed (0 = January, 7 = August), but the backend
      // expects a 1-indexed month (1 = January, 8 = August), so we add 1.
      const month = date.getMonth() + 1;
      const response = await fetch(
        '/api/wod/wodclass/account/' +
          accountIdentifier +
          '/leaderboard/year/' +
          year +
          '/month/' +
          month
      );
      const data = await response.json();
      let position = 1;
      console.log('Data from backend', data);
      const updatedData = data.map(r => ({
        avatar: r.athlete.avatar,
        rank: position++,
        name: r.athlete.firstName + ' ' + r.athlete.lastName,
        score: r.totalClasses,
        trend: 'same',
        identifier: r.athlete.identifier
      }));
      console.log('Leaderboard', updatedData);
      //const updatedData = data.map((d)=>({...d, date: this.convertDate(d.date), startTime: this.convertTime(d.startTime), endTime: this.convertTime(d.endTime)}))
      return updatedData;
    } catch (error) {
      console.error('Error fetching Class', error);
      throw error;
    }
  },
  async assignProgramToClass(identifier, programIdentifier) {
    try {
      const url =
        '/api/wod/wodclass/' + identifier + '/program/' + programIdentifier;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const updatedClass = await response.json();
        console.log('Program has been assigned to class:', updatedClass);
        return updatedClass;
      } else {
        throw new Error('Failed to assign program to class');
      }
    } catch (error) {
      console.error('Error assigning program to class', error);
      throw error;
    }
  },
  async removeBooking(identifier, profileIdentifier) {
    console.log(
      'Removing booking for class:',
      identifier,
      'and profile:',
      profileIdentifier
    );
    try {
      const response = await fetch(
        '/api/wod/wodclass/cancel/' + identifier + '/' + profileIdentifier,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.ok) {
        const cancellationConfirmation = await response.json();
        console.log(
          'Class booking has been cancelled:',
          cancellationConfirmation
        );
      }
    } catch (error) {
      console.log('Error cancelling Class booking', error);
    }
  },
  async cancelBooking(formData) {
    try {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const response = await fetch(
        '/api/wod/wodclass/cancel/' +
          formData.identifier +
          '/' +
          profile.identifier,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      );
      if (response.ok) {
        const cancellationConfirmation = await response.json();
        console.log(
          'Class booking has been cancelled:',
          cancellationConfirmation
        );
      }
    } catch (error) {
      console.log('Error cancelling Class booking', error);
    }
  },
  async leaveWaitlist(wodClass) {
    const profile = JSON.parse(localStorage.getItem('profile'));
    this.leaveWaitlist(wodClass.identifier, profile.identifier)
      .then(response => {
        console.log('Removed from waitlist:', response);
      })
      .catch(error => {
        console.error('Error removing from waitlist', error);
      });
  },
  async leaveWaitlist(identifier, profileIdentifier) {
    try {
      const response = await fetch(
        '/api/wod/wodclass/waitlist/' + identifier + '/' + profileIdentifier,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.ok) {
        const waitlistRemovalConfirmation = await response.json();
        console.log('Removed from waitlist:', waitlistRemovalConfirmation);
      }
    } catch (error) {
      console.log('Error removing from waitlist', error);
    }
  },
  async bookClass(formData) {
    const profile = JSON.parse(localStorage.getItem('profile'));

    try {
      const response = await fetch(
        `/api/wod/wodclass/${formData.identifier}/${profile.identifier}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      );

      const data = await response.json();

      if (!response.ok) {
        const error = new Error(data.message || 'Unable to book the class');
        error.code = data.code;
        error.status = response.status;

        throw error;
      }

      return data;
    } catch (error) {
      console.error('Error booking class:', error);
      throw error; // Let the React component display the message
    }
  },
  async retrieveClass(identifier) {
    try {
      const response = await fetch('/api/wod/wodclass/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Class', error);
      throw error;
    }
  },
  async addToClass(identifier, profileIdentifier) {
    try {
      const url = '/api/wod/wodclass/' + identifier + '/' + profileIdentifier;
      console.log('Adding to class:', url);
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const additionConfirmation = await response.json();
        console.log('Added to class:', additionConfirmation);
      }
    } catch (error) {
      console.log('Error adding to class', error);
    }
  },
  async deleteClass(identifier) {
    try {
      let url = '/api/wod/wodclass/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newClass = await response.json();
        console.log('Class has been deleted:', newClass);
      }
    } catch (error) {
      console.log('Error deleting Class', error);
    }
  },
  async bookClassOnWaitlist(formData) {
    try {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const response = await fetch(
        '/api/wod/wodclass/waitlist/' +
          formData.identifier +
          '/' +
          profile.identifier,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      );
      if (response.ok) {
        const waitlistConfirmation = await response.json();
        console.log('Added to waitlist:', waitlistConfirmation);
        return waitlistConfirmation;
      }
    } catch (error) {
      console.log('Error adding to waitlist', error);
      throw error;
    }
  },
  // Formats a JS Date as 'YYYY-MM-DD', which is the format expected by
  // retrieveAllClassesByAccountAndDates (startDate/endDate).
  formatDateAsISO(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
  /**
   * Calculates the customer activity breakdown (active / semi-active / inactive)
   * for the account of the currently logged in user, based on the classes
   * attended during the last month (today - 1 month + 1 day, up to today).
   *
   * Rules used to classify an athlete, based on their number of attended
   * classes during that ~4.3 week period:
   *  - Active: 2 or more classes a week on average (>= 4.3 * 2 = 8.6 classes)
   *  - Semi-Active: around 1 class a week on average (>= 4.3 and < 8.6 classes)
   *  - Inactive: less than 1 class a week on average (< 4.3 classes, includes 0)
   *
   * The percentages are calculated against the total number of users of the
   * account (DirectoryService.retrieveUsersByAccount()) and the result is
   * cached in localStorage under the 'customerActivity' key so that the
   * "change" attribute can be calculated by comparing against the
   * previously stored values the next time this method runs.
   */
  async customerActivityByAccount() {
    try {
      const today = new Date();
      const endDate = this.formatDateAsISO(today);

      const startDateObj = new Date(today);
      startDateObj.setMonth(startDateObj.getMonth() - 1);
      startDateObj.setDate(startDateObj.getDate() + 1);
      const startDate = this.formatDateAsISO(startDateObj);

      const [classes, users] = await Promise.all([
        this.retrieveAllClassesByAccountAndDates(startDate, endDate),
        DirectoryService.retrieveUsersByAccount()
      ]);

      const totalUsers = users.length;

      // Count how many classes each athlete attended during the period,
      // based on the attendance profile (attendees) of each class.
      const attendanceCountByAthlete = {};
      classes.forEach(wodClass => {
        const attendees = wodClass.attendees || [];
        attendees.forEach(attendee => {
          const id = attendee.identifier;
          attendanceCountByAthlete[id] =
            (attendanceCountByAthlete[id] || 0) + 1;
        });
      });

      // Average weeks in a month, used to translate "classes per week"
      // thresholds into "classes during the period" thresholds.
      const weeksInPeriod = 4.3;
      const activeThreshold = weeksInPeriod * 2; // 2 classes a week => 8.6
      const semiActiveThreshold = weeksInPeriod * 1; // 1 class a week => 4.3

      let activeCount = 0;
      let semiActiveCount = 0;
      let inactiveCount = 0;

      users.forEach(user => {
        const classesAttended = attendanceCountByAthlete[user.identifier] || 0;
        if (classesAttended >= activeThreshold) {
          activeCount++;
        } else if (classesAttended >= semiActiveThreshold) {
          semiActiveCount++;
        } else {
          inactiveCount++;
        }
      });

      const activePercentage =
        totalUsers > 0 ? (activeCount / totalUsers) * 100 : 0;
      const semiActivePercentage =
        totalUsers > 0 ? (semiActiveCount / totalUsers) * 100 : 0;
      const inactivePercentage =
        totalUsers > 0 ? (inactiveCount / totalUsers) * 100 : 0;

      const previousCustomerActivity = JSON.parse(
        localStorage.getItem('customerActivity')
      );

      const calculateChange = (current, previous) => {
        if (previous === undefined || previous === null) {
          return 0;
        }
        return Number((current - previous).toFixed(1));
      };

      const customerActivity = {
        active: {
          percentage: Number(activePercentage.toFixed(1)),
          change: calculateChange(
            activePercentage,
            previousCustomerActivity?.active?.percentage
          )
        },
        semiActive: {
          percentage: Number(semiActivePercentage.toFixed(1)),
          change: calculateChange(
            semiActivePercentage,
            previousCustomerActivity?.semiActive?.percentage
          )
        },
        inactive: {
          percentage: Number(inactivePercentage.toFixed(1)),
          change: calculateChange(
            inactivePercentage,
            previousCustomerActivity?.inactive?.percentage
          )
        }
      };

      localStorage.setItem(
        'customerActivity',
        JSON.stringify(customerActivity)
      );

      return customerActivity;
    } catch (error) {
      console.error('Error calculating customer activity', error);
      throw error;
    }
  }
};
export default ClassService;
